<template>
<el-card
  :body-style="{ padding: '0px' }">
  <el-row>
    <el-col>
      <transition
        name="el-zoom-in-center">
        <img
            :src="imageUrl"
            :key="imageUrl"
            class="image-sidebar"/>

      </transition>
      <div
        class="content"
        style="padding-left: 10px; padding-right: 5px;">
        <h4>
          <!-- <a
          href="javascript:void(0);"
          @click="back">{{ object.text.name }}</a> -->
          {{ object.text.name }}
          <br/>
          {{ $t('ibe.objectcode') }}: {{ object.ibeData.code }}
        </h4>
        <list-icons></list-icons>
        <hr style="margin: 15px 10px 15px 0"/>
        <list-services></list-services>
        <hr style="margin: 15px 10px 15px 0"/>
        <total-price></total-price>
        <template v-if="showFlightDetails">
          <hr style="margin: 15px 10px 15px 0"/>
          <booking-flight-details
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            fontClass="very-small-font">
          </booking-flight-details>
        </template>
        <p></p>
      </div>
    </el-col>
  </el-row>
</el-card>
</template>

<script>
import { mapGetters } from 'vuex'

import { imageMixin } from '../utils/mixins'
import ListIcons from './modules/ListIcons'
import ListServices from './modules/ListServices'
import TotalPrice from './modules/TotalPrice'
import FlightDetails from './modules/FlightDetails'

export default {
  name: 'BookingSidebar',
  mixins: [imageMixin],
  computed: {
    ...mapGetters('booking', [
      'object',
      'arrivalTransport',
      'returnTransport'
    ]),
    showFlightDetails () {
      let showArrival = false
      let showReturn = false
      showArrival = Object.keys(this.arrivalTransport).length && this.arrivalTransport.ibeData.type === 'FLIGHT'
      if (showArrival) {
        showArrival = this.arrivalTransport.segments.length > 0
      }
      showReturn = Object.keys(this.returnTransport).length && this.returnTransport.ibeData.type === 'FLIGHT'
      if (showReturn) {
        showReturn = this.returnTransport.segments.length > 0
      }
      return showArrival || showReturn
    }
  },
  methods: {
    back () {
      window.location.href = window.initData.backLink
    }
  },
  components: {
    listIcons: ListIcons,
    listServices: ListServices,
    totalPrice: TotalPrice,
    bookingFlightDetails: FlightDetails
  }
}
</script>
